export default __webpack_public_path__ + "0dd96c0651fef14aa305a95972493ac9.jpg";